import React from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var JewelryIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, props), React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M20.956 11.562L15.523 28.85a.5.5 0 0 0 .954.3l5.5-17.5a.502.502 0 0 0-.046-.404l-5-8.5a.5.5 0 1 0-.862.508l4.887 8.308z"
  }), React.createElement("path", {
    d: "M12.036 11.575l4.895-8.321a.501.501 0 0 0-.862-.508l-5 8.5a.502.502 0 0 0-.053.379l4.5 17.5a.501.501 0 0 0 .969-.25l-4.45-17.3z"
  }), React.createElement("path", {
    d: "M6.558 3.234l4.5 8.5a.5.5 0 0 0 .884-.468l-4.5-8.5a.5.5 0 0 0-.884.468zm17.98-.424l-3.5 8.5a.499.499 0 1 0 .924.38l3.5-8.5a.499.499 0 1 0-.924-.38z"
  }), React.createElement("path", {
    d: "M2.5 12h27a.5.5 0 0 0 0-1h-27a.5.5 0 0 0 0 1z"
  }), React.createElement("path", {
    d: "M30.862 10.993c.205.35.18.788-.065 1.11l-14 18.5a.998.998 0 0 1-1.594 0l-14-18.5a.999.999 0 0 1-.065-1.11l5-8.5C6.318 2.188 6.646 2 7 2h18c.354 0 .682.188.862.493l5 8.5zM24.428 4H7.572l-4.37 7.43L16 28.343 28.799 11.43 24.429 4z"
  })));
});

export default JewelryIcon;
//# sourceMappingURL=jewelry.svg.js.map
